module.exports = __webpack_public_path__ + "img/lingdang.d7ac5f9e.png";